"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var rql_1 = require("../rql");
var price_display_1 = require("./price_display");
var ribbon_view_1 = require("./ribbon_view");
var user_context_provider_1 = require("./user_context_provider");
var PriceWithShipping = /** @class */ (function (_super) {
    tslib_1.__extends(PriceWithShipping, _super);
    function PriceWithShipping() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PriceWithShipping.prototype, "standardShippingRate", {
        get: function () {
            var shippingPrice = lodash_1.get(this.props, 'listing.shipping.shippingPrices', []).find(function (price) {
                return price.shippingMethod === rql_1.core_apimessages_ShippingMethod.SHIPPED;
            });
            return shippingPrice && shippingPrice.rate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceWithShipping.prototype, "taxIncluded", {
        get: function () {
            return lodash_1.get(this.props, 'listing.taxIncluded', false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceWithShipping.prototype, "taxIncludedHint", {
        get: function () {
            return lodash_1.get(this.props, 'listing.taxIncludedHint', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceWithShipping.prototype, "showIncludedTax", {
        get: function () {
            return this.props.inlineIncludedTax && this.taxIncluded && this.taxIncludedHint !== '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PriceWithShipping.prototype, "isLive", {
        get: function () {
            return lodash_1.get(this.props, 'listing.state', '') === 'live';
        },
        enumerable: true,
        configurable: true
    });
    PriceWithShipping.prototype.isAuction = function () {
        return this.props.listing.listingType === rql_1.core_apimessages_Listing_ListingType.AUCTION;
    };
    PriceWithShipping.prototype.isFreeExpeditedShipping = function () {
        if (!this.props.listing.shipping) {
            return false;
        }
        return this.props.listing.shipping.freeExpeditedShipping;
    };
    PriceWithShipping.prototype.isLocalPickupOnly = function () {
        if (!this.props.listing.shipping) {
            return false;
        }
        return this.props.listing.shipping.localPickupOnly;
    };
    PriceWithShipping.prototype.hasDiscount = function () {
        return !!this.props.listing.pricing.originalPrice;
    };
    PriceWithShipping.prototype.ribbonText = function () {
        return this.props.listing.pricing.ribbon ?
            this.props.listing.pricing.ribbon.display :
            null;
    };
    PriceWithShipping.prototype.renderOriginalPrice = function () {
        if (!this.hasDiscount()) {
            return null;
        }
        return (React.createElement("div", { className: "price-with-shipping__price__original" }, this.props.listing.pricing.originalPrice.display));
    };
    PriceWithShipping.prototype.renderPrice = function () {
        return (React.createElement(price_display_1.default, { amountCents: this.props.listing.pricing.buyerPrice.amountCents, currency: this.props.listing.pricing.buyerPrice.currency, display: this.props.listing.pricing.buyerPrice.display, auction: this.isAuction() }));
    };
    PriceWithShipping.prototype.renderShipping = function () {
        if (this.isFreeExpeditedShipping()) {
            return (React.createElement("div", { className: "price-with-shipping__shipping price-with-shipping__shipping--expedited" }, I18n.t('cms.freeExpeditedShipping')));
        }
        if (this.isLocalPickupOnly()) {
            return (React.createElement("div", { className: "price-with-shipping__shipping" }, I18n.t('commons.localPickupOnly')));
        }
        if (this.standardShippingRate) {
            if (this.standardShippingRate.amountCents === 0) {
                return (React.createElement("div", { className: "price-with-shipping__shipping" }, I18n.t('commons.freeShipping')));
            }
            return (React.createElement("div", { className: "price-with-shipping__shipping" },
                "+",
                React.createElement("span", { className: "mlr-space" },
                    React.createElement(price_display_1.default, { amountCents: this.standardShippingRate.amountCents, currency: this.standardShippingRate.currency, display: this.standardShippingRate.display })),
                I18n.t('commons.shipping')));
        }
        return (React.createElement("div", { className: "price-with-shipping__shipping" }, I18n.t('commons.plusShipping')));
    };
    PriceWithShipping.prototype.renderIncludedTax = function () {
        if (!this.showIncludedTax)
            return;
        return (React.createElement("div", { className: "price-with-shipping__included-tax" }, this.taxIncludedHint));
    };
    PriceWithShipping.prototype.renderAcceptsOffers = function () {
        if (this.props.listing.listingType !== rql_1.core_apimessages_Listing_ListingType.MAKE_AN_OFFER)
            return null;
        return (React.createElement("div", { className: "price-with-shipping__accepts-offers" }, I18n.t('commons.acceptsOffers')));
    };
    PriceWithShipping.prototype.render = function () {
        return (React.createElement("div", { className: "price-with-shipping" },
            React.createElement("div", { className: "price-with-shipping__price" },
                this.isLive && this.renderOriginalPrice(),
                React.createElement("div", { className: "price-with-shipping__price__amount" },
                    this.renderPrice(),
                    this.props.inlineShipping && this.renderShipping(),
                    this.renderIncludedTax())),
            !this.props.inlineShipping && this.renderShipping(),
            React.createElement("div", { className: "price-with-shipping__discount" },
                React.createElement(ribbon_view_1.default, { auction: this.isAuction(), listingStateDescription: this.props.listing.stateDescription, listingStateSlug: this.props.listing.state, discountDisplay: this.ribbonText(), unstyled: true }))));
    };
    return PriceWithShipping;
}(React.Component));
exports.PriceWithShipping = PriceWithShipping;
exports.default = (user_context_provider_1.withUserContext(PriceWithShipping));
//# sourceMappingURL=price_with_shipping.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/price_with_shipping.js
// module id = APz7
// module chunks = 0 1 2 3 4 6 8 11 12 13 20